import React from "react";
import clsx from "clsx";

import { LineDivider } from "components/layout";
import { NavigationItemType } from "types";

import NavigationItem from "./navigationItem";


import styles from "./mainNavigationInfo.module.scss";

type MainNavigationInfoProps = {
	content: NavigationItemType[];
	subContent?: React.ReactNode | JSX.Element;
	title?: string;
	loading: boolean;
	className?: string;
	variant?: "reverse";
};

const MainNavigationInfo = ({
	content,
	subContent,
	title,
	loading,
	className = "",
	variant,
}: MainNavigationInfoProps) => {
	return (
		<div
			className={clsx(
				styles.mainInfo,
				variant && styles[variant],
				className,
			)}
		>
			{title && <h6 className={styles.title}>{title}</h6>}
			<ul className={styles.navList}>
				{content?.map((item, i) => {
					if (item?.hidden) return null;
					const key = `navigation_item_${i}`;

					return (
						<li key={key}>
							<NavigationItem loading={loading} item={item} />
						</li>
					);
				})}
			</ul>
			{subContent && (
				<>
					<LineDivider className={styles.subContentDivider} />
					<div className={styles.subNavList}>
						<div>{subContent}</div>
					</div>
				</>
			)}
		</div>
	);
};

export default MainNavigationInfo;
